import React from 'react';
import { Skeleton, Stack, Box } from '@mui/material';

export default function ProductCardSkeleton() {
  return (
    <Stack style={{ minHeight: '210px', position: 'relative' }}>
      <Box>
        <Skeleton variant="rectangular" width="100%" height={0} sx={{ paddingTop: '75%', borderRadius: '15px' }} />
        <Skeleton variant="text" height={24} sx={{ mt: 1 }} />
        <Skeleton variant="text" width="60%" height={18} />
        <Skeleton variant="text" width="80%" height={18} />
        <Skeleton variant="text" width="40%" height={20} />
      </Box>
    </Stack>
  );
}
